import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/auth";
import { AppShell } from "@/components/AppShell";
import { Spinner } from "@/components/ui";

import ResetPassword from "./pages/ResetPassword";
import Login from "@/pages/Login";
import Home from "@/pages/Home";
import Repertorio from "@/pages/Repertorio";
import Estudar from "@/pages/Estudar";
import Song from "@/pages/Song";
import Naipe from "@/pages/Naipe";
import Chat from "@/pages/Chat";
import Perfil from "@/pages/Perfil";
import Calendar from "@/pages/Calendar";
import Announcements from "@/pages/Announcements";
import Attendance from "@/pages/Attendance";
import Password from "@/pages/Password";
import EventPage from "@/pages/Event";
import OfficialSetlist from "@/pages/OfficialSetlist";
import AdminMembers from "@/pages/admin/AdminMembers";
import AdminSongs from "@/pages/admin/AdminSongs";
import AdminSetlists from "@/pages/admin/AdminSetlists";
import AdminEvents from "@/pages/admin/AdminEvents";
import AdminAnnouncements from "@/pages/admin/AdminAnnouncements";
import AdminAttendance from "@/pages/admin/AdminAttendance";
import AdminAttendanceDetail from "@/pages/admin/AdminAttendanceDetail";
import AdminRoles from "@/pages/admin/AdminRoles";
import EventAvailabilityPage from "@/pages/EventAvailability";
import Playlists from "@/pages/Playlists";
import { PlaylistDetail, SharedPlaylist } from "@/pages/PlaylistDetail";
import { PlayerProvider } from "@/lib/player";
import { can, ADMIN_NAV, AVAILABILITY_PERMS } from "@/lib/permissions";

function Protected({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) return <div className="app-root" style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center" }}><Spinner pad={false} /></div>;
  if (!user) return <Navigate to="/login" replace state={{ from: location }} />;
  return <AppShell>{children}</AppShell>;
}

// Any of `perms` grants access; the backend enforces the same rules on every request.
function RequirePerm({ perms, children }) {
  const { user } = useAuth();
  if (user && !can(user, ...perms)) return <Navigate to="/" replace />;
  return children;
}

const navPerms = (to) => ADMIN_NAV.find((n) => n.to === to).perms;
const guard = (to, el) => <Protected><RequirePerm perms={navPerms(to)}>{el}</RequirePerm></Protected>;

export default function App() {
  return (
    <BrowserRouter>
      <PlayerProvider>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/recuperar" element={<ResetPassword />} />
        <Route path="/" element={<Protected><Home /></Protected>} />
        <Route path="/repertorio" element={<Protected><Repertorio /></Protected>} />
        <Route path="/estudar" element={<Protected><Estudar /></Protected>} />
        <Route path="/listas" element={<Protected><Playlists /></Protected>} />
        <Route path="/listas/:id" element={<Protected><PlaylistDetail /></Protected>} />
        <Route path="/lista" element={<Protected><SharedPlaylist /></Protected>} />
        <Route path="/song/:id" element={<Protected><Song /></Protected>} />
        <Route path="/naipe" element={<Protected><Naipe /></Protected>} />
        <Route path="/chat/:room" element={<Protected><Chat /></Protected>} />
        <Route path="/perfil" element={<Protected><Perfil /></Protected>} />
        <Route path="/calendar" element={<Protected><Calendar /></Protected>} />
        <Route path="/announcements" element={<Protected><Announcements /></Protected>} />
        <Route path="/attendance" element={<Protected><Attendance /></Protected>} />
        <Route path="/password" element={<Protected><Password /></Protected>} />
        <Route path="/setlist/:eventId" element={<Protected><EventPage /></Protected>} />
        <Route path="/events/:eventId" element={<Protected><EventPage /></Protected>} />
        <Route path="/alinhamentos/:id" element={<Protected><OfficialSetlist /></Protected>} />
        <Route path="/admin/members" element={guard("/admin/members", <AdminMembers />)} />
        <Route path="/admin/roles" element={guard("/admin/roles", <AdminRoles />)} />
        <Route path="/admin/songs" element={guard("/admin/songs", <AdminSongs />)} />
        <Route path="/admin/setlists" element={guard("/admin/setlists", <AdminSetlists />)} />
        <Route path="/admin/events" element={guard("/admin/events", <AdminEvents />)} />
        <Route path="/admin/announcements" element={guard("/admin/announcements", <AdminAnnouncements />)} />
        <Route path="/admin/attendance" element={guard("/admin/attendance", <AdminAttendance />)} />
        <Route path="/admin/attendance/:eventId" element={guard("/admin/attendance", <AdminAttendanceDetail />)} />
        <Route path="/events/:eventId/disponibilidade" element={<Protected><RequirePerm perms={AVAILABILITY_PERMS}><EventAvailabilityPage /></RequirePerm></Protected>} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      </PlayerProvider>
    </BrowserRouter>
  );
}
